/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Language_LabelInputs */



/**
* | output |
* | --- |
* | "Language" |
*
* @param {Edit_Event_Group_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_language_label = /** @type {((inputs?: Edit_Event_Group_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprache")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lingua")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Язык")
	if (locale === "es") return /** @type {LocalizedString} */ ("Idioma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("言語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भाषा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linguagem")
	return /** @type {LocalizedString} */ ("Language")
});